angular.module('SpidApp')

.factory('CurrencyService',
	    ['Restangular', '_', 'Currency',
function (Restangular,   _,   Currency) {
	var CurrencyService = {
		all: function () {
			return Restangular.all('currencies').getList().then(function (currenciesData) {
				return _.map(currenciesData, function (currencyData) {
					return new Currency(currencyData)
				})
			})
		},

		findRefCurrency: function () {
			return this.all().then(function (currenciesData) {
				return _.find(currenciesData, function (currencyData) {
					return currencyData.keycode === 'EUR'
				})
			})
		},

		find: function (id) {
			if (!id) {
				throw 'CurrencyService::find() - Missing parameters'
			}

			return Restangular.one('currencies', id).get().then(function (currencyData) {
				return new Currency(currencyData)
			})
		},
		
		update: function(currency, agencyId) {
			if (!currency || !agencyId) {
				throw 'CurrencyService::save() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).one("currencies", currency.id).post(null, currency);
		} 
	}

	return CurrencyService
}])
